import { render, staticRenderFns } from "./CreateV2.vue?vue&type=template&id=1a38cbbf&scoped=true&"
import script from "./js/CreateV2.js?vue&type=script&lang=js&"
export * from "./js/CreateV2.js?vue&type=script&lang=js&"
import style0 from "./CreateV2.vue?vue&type=style&index=0&id=1a38cbbf&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a38cbbf",
  null
  
)

export default component.exports